export const FETCH_DATASETS_PAGE = '@@datasets-page/FETCH_DATASETS_PAGE';
export const FETCH_DATASETS_PAGE_SUCCESS = '@@datasets-page/FETCH_DATASETS_PAGE_SUCCESS';
export const FETCH_DATASETS_PAGE_ERROR = '@@datasets-page/FETCH_DATASETS_PAGE_ERROR';

export const FETCH_DATASETS_FILTERS = '@@datasets-page/FETCH_DATASETS_FILTERS';
export const FETCH_DATASETS_FILTERS_SUCCESS = '@@datasets-page/FETCH_DATASETS_FILTERS_SUCCESS';
export const FETCH_DATASETS_FILTERS_ERROR = '@@datasets-page/FETCH_DATASETS_FILTERS_ERROR';
